export const TokenKey = 'token'

export function getToken() {
  return localStorage.getItem(TokenKey)
}

export function setToken(token) {
  return localStorage.setItem(TokenKey, token)
}

export function removeToken() {
  return localStorage.removeItem(TokenKey)
}
// json格式需要序列化
export function setStorage(key, data) {
  if (!key) return
  localStorage.setItem(key, JSON.stringify(data))
}
export function getStorage(key) {
  const item = localStorage.getItem(key)
  return item ? JSON.parse(item) : ''
}
export function removeStorage(key) {
  return localStorage.removeItem(key)
}
